module.exports = "https://static.wmbcdn.com/uniweb/images/72de7eea90c4470268383afa0f8495d2.svg";